<template>
  <div class="table-root">
    <div class="content">
      <div v-if="!hiddenHeader" class="header-row">
        <TableHeader v-if="isSelectable" class="checkbox">
          <Checkbox :checked="isAllSelected" @change="toggleAll()" />
        </TableHeader>
        <slot name="header" />
      </div>
      <div
        v-for="item in items"
        :key="item.id"
        class="body-row"
        :class="{ clickable: $listeners['row-click'] }"
        @click="onClickRow($event, item)"
      >
        <TableCell v-if="isSelectable" class="click-ignore">
          <Checkbox :checked="isSelected(item)" @change="toggleSelect(item)" />
        </TableCell>
        <slot name="body" :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import TableHeader from "@/components/shop/TableHeader.vue";
import TableCell from "@/components/shop/TableCell.vue";
import Checkbox from "@/components/shop/Checkbox.vue";

export default {
  components: {
    TableHeader,
    TableCell,
    Checkbox
  },

  props: {
    items: {
      type: Array,
      required: true
    },
    selected: {
      type: Array,
      default: null
    },
    hiddenHeader: {
      type: Boolean,
      default: false
    },
    sort: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    isSelectable() {
      return this.selected !== null;
    },
    isAllSelected() {
      return this.isSelectable && this.items.every(this.isSelected);
    }
  },

  data() {
    return {
      provideSort: { ...this.sort }
    };
  },

  watch: {
    sort() {
      this.$set(this.provideSort, "name", this.sort.name);
      this.$set(this.provideSort, "order", this.sort.order);
    }
  },

  provide() {
    return {
      sort: this.provideSort,
      updateSort: this.updateSort
    };
  },

  methods: {
    isSelected(item) {
      return this.selected.includes(item.id);
    },
    toggleAll() {
      let selectedIds;
      if (this.isAllSelected) {
        selectedIds = this.selected.filter(id => !this.items.some(item => item.id === id));
      } else {
        const deltaItems = this.items.filter(item => !this.selected.includes(item.id));
        selectedIds = this.selected.concat(deltaItems.map(item => item.id));
      }
      this.$emit("update:selected", selectedIds);
    },
    toggleSelect(item) {
      if (this.isSelectable) {
        let selectedIds;
        if (this.isSelected(item)) {
          selectedIds = this.selected.filter(id => id !== item.id);
        } else {
          selectedIds = this.selected.concat(item.id);
        }
        this.$emit("update:selected", selectedIds);
      }
    },
    updateSort(sort) {
      this.$emit("update:sort", sort);
    },
    onClickRow(e, item) {
      if (!e.target.closest(".table-root .click-ignore")) {
        this.$emit("row-click", item);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-root {
  overflow-y: visible;
  overflow-x: auto;
}

.content {
  display: table;
  min-width: 100%;
  width: max-content;
  border: 1px #ccc solid;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  text-align: left;
  border-radius: inherit;
}

.header-row {
  display: table-row;
  background-color: #eee;

  > .checkbox {
    width: 40px;
  }
}

.body-row {
  display: table-row;

  &.clickable {
    cursor: pointer;
  }

  &:nth-child(odd) {
    background-color: #f5f5f5;
  }
  &:nth-child(even) {
    background-color: #fff;
  }
}

.click-ignore {
  cursor: initial;
}
</style>
